import { render } from "./AddClientPage.vue?vue&type=template&id=6f47361b&ts=true"
import script from "./AddClientPage.vue?vue&type=script&lang=ts"
export * from "./AddClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__